const defaultProps = {
  fill: 'none',
  stroke: '#E3E7EDFF',
  strokeWidth: '1',
  strokeDasharray: '8, 8',
  strokeDashoffset: '0',
  borderRadius: 0
};

export function createDashedBorder(props = defaultProps) {
  const svgProps = { ...defaultProps, ...props };
  const {
    fill,
    stroke,
    strokeWidth,
    strokeDasharray,
    strokeDashoffset,
    strokeLinecap,
    borderRadius
  } = svgProps;
  return `background-image: url("data:image/svg+xml,
${encodeURIComponent(`<svg width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'>
<rect
width='100%'
height='100%'
fill='${fill}'
stroke='${stroke}'
stroke-width='${strokeWidth}'
stroke-dasharray='${strokeDasharray}'
stroke-dashoffset='${strokeDashoffset}'
stroke-linecap='${strokeLinecap}'
rx='${borderRadius}'
/>
</svg>`)}");`;
}
